import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">专题索引</h2>
        <p className="text-sm text-foreground-500 mb-10">按内容类型快速定位，找到你最想看的精彩内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200 flex-shrink-0">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-base font-semibold font-heading text-foreground-800 truncate">{item.title}</h3>
                  <span className="text-xs text-primary-500 font-semibold whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}